
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M50 5C25.147 5 5 25.147 5 50c0 24.854 20.147 45 45 45 24.854 0 45-20.146 45-45C95 25.147 74.854 5 50 5zM29.25 67.5h-5V44.307h5zm6 0h-5v-38h5zm7.5 0h-5v-27h5zm6 0h-5v-42h5zm7.5 0h-5v-21h5zm6 0h-5v-41h5zm7.5 0h-5v-29h5zm6 0h-5v-44h5z"}})])
      }
    
      }
    